<template>
    <div
        class="sidebar-menu-item"
        :class="{ selected: isSelected(item) }"
        @click="fnCallback(item)"
        :data-menukey="item.dataKey"
        @mouseover="hoverActive = true"
        @mouseleave="hoverActive = true"
    >
        <template v-if="item.icon.type === 'material-icons'">
            <div class="sidebar-menu-item-icon">
                <div class="material-icons">{{ item.icon.name }}</div>
                <div class="minimize-badge" v-if="item.counter >= 0 && !isMenuActive()">
                    {{ item.counter }}
                </div>
                <div class="minimize-badge" v-if="item.counter >= 0 && !isMenuActive() && item.key === 4">
                    {{ item.counter }}
                </div>
            </div>
        </template>
        <template v-if="item.icon.type === 'chatbot'">
            <div class="sidebar-menu-item-icon">
                <div class="material-icons">
                    <Chatbot />
                </div>
                <div class="minimize-badge" v-if="item.counter >= 0 && !isMenuActive()">
                    {{ item.counter }}
                </div>
                <div class="minimize-badge" v-if="item.counter >= 0 && !isMenuActive() && item.key === 4">
                    {{ item.counter }}
                </div>
            </div>
        </template>
        <template v-else-if="item.icon.type === 'component'">
            <div class="sidebar-menu-item-icon">
                <component
                    v-bind:is="item.icon.name"
                    id="component-icon"
                    :class="item.icon.class"
                    :style="item.icon.style"
                />
            </div>
        </template>
        <div class="sidebar-menu-item-content">
            <div class="sidebar-menu-item-text" :title="item.label">
                {{ item.label }}
            </div>
            <div v-if="showDeleteButton && hoverActive" class="delete-icon" @click.stop="handleDelete">
                <i class="material-icons">clear</i>
            </div>
            <div class="sidebar-menu-item-count" v-if="item.counter >= 0 && !(showDeleteButton && hoverActive)">
                {{ item.counter }}
            </div>
        </div>
    </div>
</template>
<script>
import InstagramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import TicketIcon from "../svg/Ticket.vue";
import MessengerIcon from "../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import FacebookIcon from "../../views/Pages/Chatbot/pages/integrations/svg/NewFacebookIcon.vue";
import WhatsappIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import OfflineSupWaiting from "../svg/OfflineSupWaiting.vue";
import ArchiveIcon from "../svg/ArchiveIcon.vue";
import Chatbot from "../svg/Chatbot.vue";
import TrendyolIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import CreditCard from "../svg/CreditCard.vue";
import TelegramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import LinkedinIcon from "../../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";

export default {
    name: "SidebarChildItem",
    props: ["item", "isSelected", "isMenuActive", "showDeleteButton", "onDelete"],
    components: {
        InstagramIcon,
        MessengerIcon,
        WhatsappIcon,
        TelegramIcon,
        LinkedinIcon,
        TrendyolIcon,
        OfflineSupWaiting,
        ArchiveIcon,
        Chatbot,
        CreditCard,
        TicketIcon,
        FacebookIcon
    },
    data() {
        return {
            isActive: false,
            groupedItems: [],
            cloneItems: [],
            selectedItemClone: null,
            hoverActive: true,
        };
    },
    methods: {
        fnCallback() {
            if (this.item.clickEvent) {
                this.$emit("clicked", this.item);
            } else {
                this.$emit("selected", this.item);
            }
        },
        handleDelete() {
            if (typeof this.onDelete === "function") {
                this.onDelete(this.item);
            }
        },
    },
};
</script>
<style lang="scss">
.hiddenToolTip {
    opacity: 0 !important;
    display: none !important;
}
</style>
<style lang="scss">
.sidebar-tool {
    width: 60px;
    border-right: 1px solid var(--color-border-default);
    height: 100%;
    position: relative;
    transition: all 0.2s;
    user-select: none;
    min-width: 60px;
    z-index: 1;

    .sidebar-content {
        height: calc(100% - 40px);
        overflow: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &.active {
        width: 240px;
        min-width: 240px;

        .sidebar-menu-item {
            .sidebar-menu-item-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
            }
        }

        .sidebar-grouped {
            .sidebar-grouped-head {
                justify-content: space-between;

                .sidebar-grouped-head-title {
                    display: block !important;
                }
            }
        }

        .sidebar-tool-collapse {
            padding: 0 10px;
            justify-content: space-between;

            .information-text {
                display: block !important;
            }
        }
    }

    .sidebar-menu {
        transition: all 0.2s;
        max-height: 400px; // 10 item
        overflow: hidden;
        opacity: 1;

        &.closed {
            max-height: 0;
            opacity: 0;
        }
    }

    .sidebar-menu-content {
        padding: 11px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        line-height: 0;
        background: var(--white);
    }

    .sidebar-menu-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        padding: 8px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background: var(--color-bg-neutral-hover);
        }

        .ig-background {
            fill: #d6249f;
        }

        .wp-background {
            fill: #58c963;
        }

        &.selected {
            background: var(--color-bg-active);

            .sidebar-menu-item-text {
                white-space: nowrap;
                color: var(--color-text-primary-strong-active) !important;
            }

            .material-icons {
                color: var(--color-icon-primary-default) !important;
            }

            .wp-background {
                fill: var(--color-icon-primary-default) !important;
            }

            .ig-background {
                fill: var(--color-icon-primary-default) !important;
            }

            .credit-card {
                fill: var(--color-icon-primary-default) !important;
            }
        }

        &:not(&.selected) {
            .sidebar-menu-item-content {
                .sidebar-menu-item-text {
                    white-space: nowrap;
                    color: var(--menu-list-icon-color) !important;
                }
            }
        }

        .sidebar-menu-item-icon {
            width: 20px;
            height: 20px;
            font-size: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-right: 8px;

            svg {
                width: 100%;
                height: 100%;
            }

            .myIcon {
                width: 100%;
                height: 100%;
            }

            .material-icons {
                font-size: 20px;
                color: var(--default-text-color);
            }

            .minimize-badge {
                position: absolute;
                background: var(--color-badge-default);
                font-size: 12px;
                line-height: 0;
                width: 15px;
                height: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                top: 0;
                right: -5px;
                color: var(--default-text-color-reverse);
            }

            #component-icon {
                width: 20px;
                height: 20px;
            }
        }

        .sidebar-menu-item-content {
            display: none;

            .sidebar-menu-item-count {
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                border-radius: 5px;
                border: 1px solid var(--color-border-default);
                color: var(--default-text-color);
            }
        }

        .sidebar-menu-item-text {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: calc(100% - 60px) !important;
            min-width: calc(100% - 60px) !important;
            color: var(--color-text-primary);
            font-size: 14px;
            line-height: 1.5;
        }
    }

    &.selected {
        .sidebar-menu-item-count {
            border: 1px solid var(--color-text-primary-strong-active);
        }
    }

    .sidebar-grouped {
        width: 100%;
        display: flex;
        flex-direction: column;

        .sidebar-grouped-head {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border: var(--color-border-default);
            border-style: solid;
            border-width: 1px 0;
            border-bottom-width: 0;
            padding: 7px 11px;
            cursor: pointer;

            .sidebar-grouped-head-title {
                display: none;
                white-space: nowrap;
                width: 100%;
                line-height: 0;
            }

            .sidebar-grouped-head-collapse {
                line-height: 0;

                .material-icons {
                    font-size: 16px;
                }
            }
        }
    }

    .sidebar-tool-collapse {
        position: absolute;
        border-top: 1px solid var(--color-border-default);
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        cursor: pointer;
        user-select: none;
        background-color: var(--color-bg-neutral-default);
        height: 40px;

        .information-text {
            display: none;
            white-space: nowrap;
        }
    }

    .sidebar-menu-item-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: calc(100% - 60px) !important;
        min-width: calc(100% - 60px) !important;
        color: var(--color-text-primary);
    }
}

.sidebar-menu-item-content {
    position: relative;
    overflow: hidden;

    .delete-icon {
        cursor: pointer;
        color: red;
        font-size: 14px;
        width: 20px;
        height: 20px;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        transition: background-color 0.3s, color 0.3s;
    }

    .sidebar-menu-item:hover .delete-icon {
        display: flex;
        background-color: darkred;
    }
}
</style>
